import { render, staticRenderFns } from "./checkbox-tertiary.vue?vue&type=template&id=6dd2bb17&scoped=true&"
import script from "./checkbox-tertiary.vue?vue&type=script&lang=js&"
export * from "./checkbox-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd2bb17",
  null
  
)

export default component.exports